<template>
  <div class="app-wrapper" :class="{hideSidebar:!sidebar.opened}">
    <sidebar v-if="!POWERED_BY_QIANKUN" class="sidebar-container"></sidebar>
    <div :class="{'main-container': !POWERED_BY_QIANKUN}">
      <navbar :key="key" v-if="!POWERED_BY_QIANKUN"></navbar>
      <!-- <breadcrumb></breadcrumb> -->
      <app-main @displayNameChange="handleDisplayNameChange"></app-main>
    </div>
  </div>
</template>

<script>
import { Navbar, Sidebar, AppMain } from '@/views/layout/components'
import Breadcrumb from '@/components/Breadcrumb'

export default {
  name: 'layout',
  components: {
    Navbar,
    Sidebar,
    AppMain,
    Breadcrumb
  },
  data() {
    return {
      key: '',
      POWERED_BY_QIANKUN: window.__POWERED_BY_QIANKUN__
    }
  },
  computed: {
    sidebar() {
      return this.$store.state.app.sidebar
    }
  },
  methods: {
    handleDisplayNameChange(val) {
      this.key = val
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
@import "src/styles/mixin.scss";
.app-wrapper {
  @include clearfix;
  position: relative;
  height: 100%;
  width: 100%;
}
.hidSty{
  min-height:100px !important;
  color:#fff;
}
</style>



// WEBPACK FOOTER //
// src/views/layout/Layout.vue